import i18n from '@/i18n'
export const nbaColumns = [
  {
    key: 'productName',
    label: i18n.tc('digitalServices.purchaseTable.name'),
    width: '50%'
  },
  {
    key: 'dateOfActivation',
    label: i18n.tc('digitalServices.purchaseTable.activationDate'),
    colClass: 'flex-grow-1',
    width: '50%'
  },
  {
    key: 'code',
    label: i18n.tc('digitalServices.purchaseTable.codeLabel'),
    colClass: 'code-cell',
    width: '160px',
    slot: 'status'
  }
]

export const siguranNetColumns = [
  {
    key: 'contractName',
    label: i18n.tc('digitalServices.siguranNet.activityTable.contract'),
    width: '30%'
  },
  {
    key: 'actualPrice',
    label: i18n.tc('digitalServices.siguranNet.activityTable.price'),
    width: '30%',
    slot: 'price'
  },
  {
    key: 'dateOfActivation',
    label: i18n.tc('digitalServices.siguranNet.activityTable.activationDate'),
    width: '30%'
  },
  {
    key: 'dateOfDeactivation',
    label: i18n.tc('digitalServices.siguranNet.activityTable.deactivationDate'),
    width: '30%',
    slot: 'deactivationDate'
  }
]

export const serviceCommonColumns = (serviceName) => [
  {
    key: 'productName',
    width: '40%',
    label: i18n.tc(`digitalServices.${serviceName}.purchaseTable.name`)
  },
  {
    key: 'recurring',
    label: i18n.tc(`digitalServices.${serviceName}.purchaseTable.status`),
    width: '40%',
    formatter: value => {
      return value ? i18n.tc(`digitalServices.${serviceName}.purchaseTable.recurringLabel`) : '-'
    }
  },
  {
    key: 'activationField',
    label: i18n.tc(`digitalServices.${serviceName}.purchaseTable.url`),
    width: '20%',
    colClass: 'code-cell',
    slot: `${serviceName}Status`
  }
]
